import { Component, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { OldIconConfig } from '../../core-ui/OldIcon/OldIconConfig';

@Component({
    selector: 'bullet-box',
    template: `
        <div
            name="bulletBox"
            class="bulletBox"
            [ngClass]="[getBoxColorClass(), getExpansionClass()]"
        >
            <div class="bulletBox_header">
                <div class="bulletBox_header_bullet"></div>
                @if (boxHeadingIcon) {
                    <old-icon [properties]="boxHeadingIcon"></old-icon>
                }
                {{ boxHeading }}
                <span
                    class="ico-moon ico-moon-circle-down2"
                    (click)="toggleExpansion()"
                ></span>
            </div>
            <div class="bulletBox_bulletList">
                <ul>
                    @for (item of boxBullets; track item) {
                        <li class="bulletBox_bulletList_bullet">
                            {{ item }}
                        </li>
                    }
                </ul>
            </div>
        </div>
    `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: BulletBoxComponent,
            multi: true
        }
    ],
    standalone: false
})
export class BulletBoxComponent implements OnInit {
    @Input()
    boxColor: string;
    @Input()
    boxHeading: string;
    @Input()
    boxHeadingIcon: OldIconConfig;
    @Input()
    boxBullets: string[];
    @Input()
    startExpanded = true;

    propagateChange = (_: any) => {
        /* No change propagated */
    };
    private _expanded: boolean;

    ngOnInit() {
        this.expanded = this.startExpanded;
    }

    toggleExpansion() {
        this.expanded = !this.expanded;
    }

    getBoxColorClass() {
        return `bulletBox-${this.boxColor}`;
    }

    getExpansionClass() {
        return this.expanded ? 'bulletBox-expanded' : '';
    }

    get expanded() {
        return this._expanded;
    }
    set expanded(val) {
        this._expanded = val;
        this.propagateChange(this._expanded);
    }
    writeValue(value: any): void {
        this.expanded = value;
    }
    registerOnChange(fn: any): void {
        this.propagateChange = (changed) => fn.call(this, changed);
    }
    registerOnTouched(): void {
        /* No callback function registered OnTouched */
    }
}
